var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpeechBubble = function SvgSpeechBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.765,
    height: 16.373,
    viewBox: "0 0 18.765 16.373",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_471",
    "data-name": "Union 471",
    d: "M-3878.559,15962.927a.446.446,0,0,1-.281-.421v-5.164a.444.444,0,0,1,.469-.469.444.444,0,0,1,.469.469v4.038l4.363-4.362a.424.424,0,0,1,.328-.145h2.348a4.469,4.469,0,0,0,3.285-1.358,4.65,4.65,0,0,0,1.358-3.333,4.705,4.705,0,0,0-4.691-4.691h-7.459a4.63,4.63,0,0,0-3.329,1.362,4.8,4.8,0,0,0-1.362,3.329,4.64,4.64,0,0,0,2.58,4.179.422.422,0,0,1,.188.609.424.424,0,0,1-.609.188,5.4,5.4,0,0,1-3.1-4.976,5.558,5.558,0,0,1,1.643-3.986,5.709,5.709,0,0,1,3.986-1.594h7.508a5.643,5.643,0,0,1,5.629,5.629,5.549,5.549,0,0,1-1.642,3.985,5.549,5.549,0,0,1-3.986,1.643h-2.2l-4.976,4.976a.5.5,0,0,1-.329.141A.279.279,0,0,1-3878.559,15962.927Zm8.024-9.491a.443.443,0,0,1-.469-.469.442.442,0,0,1,.469-.469h1.126a.442.442,0,0,1,.469.469.471.471,0,0,1-.469.469Zm-4.691,0a.443.443,0,0,1-.469-.469.442.442,0,0,1,.469-.469h1.122a.443.443,0,0,1,.473.469.472.472,0,0,1-.473.469Zm-4.691,0a.443.443,0,0,1-.469-.469.442.442,0,0,1,.469-.469h1.122a.44.44,0,0,1,.469.469.469.469,0,0,1-.469.469Z",
    transform: "translate(3883.999 -15946.602)",
    fill: "#07a3c8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeechBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speechBubble.6f94110c.svg";
export { ForwardRef as ReactComponent };